var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0c-4.963 0-9 4.037-9 9v3.729c0 .921.807 1.671 1.8 1.671h.9a.9.9 0 0 0 .9-.9V8.871a.9.9 0 0 0-.9-.9h-.817C2.883 4.488 5.88 1.8 9.5 1.8s6.617 2.688 7.117 6.171H15.8a.9.9 0 0 0-.9.9V14.4c0 .993-.807 1.8-1.8 1.8h-1.8v-.9H7.7V18h5.4c1.985 0 3.6-1.615 3.6-3.6.993 0 1.8-.75 1.8-1.671V9c0-4.963-4.037-9-9-9Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupport);
export default __webpack_public_path__ + "static/media/ic_support.6e1645b933dc92f2d177f9013a2543fa.svg";
export { ForwardRef as ReactComponent };